import DownloadIcon from '@mui/icons-material/Download';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import * as constants from '../../store/Constants';
import { Recipe } from '../../store/Recipe';
import { getLocalStorage } from '../../utils/LocalStorageHelpers';
import { getRecipeIndex } from '../../utils/ServerCommunications';
import { SyncState } from '../../utils/ServerCommunications';

function refreshPage() {
  window.location.href = "/mak-protocols";
}

function copyUrl() {
  console.log(window.location.href)
  if (!navigator.clipboard) {
    console.log("Clipboard API not available")
  } else {
    window.navigator.clipboard.writeText(window.location.href);
  }
}

interface SettingsInterface {
  state: boolean
  setState: (value: React.SetStateAction<boolean>) => void
  setRecipeIndex: React.Dispatch<React.SetStateAction<Recipe[]>>
}

const Settings = (props: SettingsInterface) => {
  // Check if local storage is available.
  const localStorageResult = getLocalStorage();
  var lastSync = <p>Last Sync: ?</p>
  if (localStorageResult.date !== undefined) {
    lastSync = <p>Last Sync: {localStorageResult.date.toLocaleString()}</p>
  }

  var initialUrlState = ""
  if (localStorageResult.url !== constants.DefaultUrl) {
    initialUrlState = localStorageResult.url
  }

  // Local state for custom URL. Does not override default URL.
  const [customUrlState, setCustomUrlState] = React.useState(initialUrlState)
  const handleCustomUrl = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setCustomUrlState(event.target.value)
  }

  // Local state for icon.
  const [syncIconState, setSyncIconState] = React.useState(SyncState.COMPLETE)
  function setSyncIconHelper(state: SyncState) {
    setSyncIconState(state)
  }

  const isSyncing = (syncIconState === SyncState.IN_PROGRES)

  const syncHelper = (url: string) => {
    getRecipeIndex({
      url: url,
      setData: (index: Recipe[]) => { props.setRecipeIndex(index) },
      setStatus: setSyncIconHelper
    })
  }

  const toggleDrawer =
    (open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
          event.type === 'keydown' &&
          ((event as React.KeyboardEvent).key === 'Tab' ||
            (event as React.KeyboardEvent).key === 'Shift')
        ) {
          return;
        }

        props.setState(open);
      };

  return (
    <div>
      <Drawer
        anchor={'right'}
        open={props.state}
        onClose={toggleDrawer(false)}
      >
        <Box
          sx={{
            width: 250,
            padding: "10px"
          }}
        >
          <Stack spacing={2}>
            <p>Clicking sync will sync the app with the latest available data, downloaded from the MAK recipe spreadsheet.</p>
            <Button
              variant="contained"
              onClick={() => syncHelper(constants.DefaultUrl)}
              disabled={isSyncing}
            >
              Sync
            </Button>
            {lastSync}
            <Divider />
            <p>Clicking share will copy the current URL query to your clipboard to easily share a specific search with your best friends or family.</p>
            <Button
              variant="contained"
              onClick={copyUrl}
              disabled={!navigator.clipboard}
            >
              Share
            </Button>
            <Divider />
            <p>Clicking reload will remove the query and reload the website.</p>
            <Button
              variant="contained"
              onClick={refreshPage}
            >
              Reload
            </Button>
            <Divider />
            <p>A custom URL can be specifed to pull from a different .csv source. Clicking sync above will reset this field and use the website default instead.</p>
            <TextField
              id="url"
              label="Custom URL"
              type="url"
              variant="outlined"
              value={customUrlState}
              onChange={handleCustomUrl}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => syncHelper(customUrlState)}
                      edge="end"
                      color="primary"
                    >
                      <DownloadIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              multiline={false}
            />
          </Stack>
        </Box>
      </Drawer>
    </div>
  )
}

export default Settings
